import { ref, computed, watch } from "vue";
import { disableBeforeUnload } from "@/utils/unloadGuard";

export function useCallDispositionState(
  currentCallSid: any,
  logCallLogDetailsMutation: any,
  callDispositions: any,
  reactiveContact: any,
  toast: any
) {
  const selectedCallDisposition = ref<any>(null);
  const callDispositionError = ref<string | null>(null);
  const mustLogAfterCall = ref(false);
  const hasCallBeenLogged = ref(false);
  const hasBaseCallLogCreated = ref(false);

  const isCallDispositionRequired = computed(
    () => !!(currentCallSid.value && !hasCallBeenLogged.value)
  );

  const canProceedWithCall = computed(() => {
    if (!isCallDispositionRequired.value) {
      return true;
    }
    return !!selectedCallDisposition.value;
  });

  async function logCallBySid() {
    const payload: any = { callSid: currentCallSid.value };
    if (selectedCallDisposition.value) {
      payload.callDispositionId = selectedCallDisposition.value.id;
    }
    await logCallLogDetailsMutation(payload);
    toast.success("Call has been logged");
    currentCallSid.value = null;
    mustLogAfterCall.value = false;
    disableBeforeUnload();
    callDispositionError.value = null;
    hasCallBeenLogged.value = true;
  }

  function onCallDispositionChange(disposition: any) {
    selectedCallDisposition.value = disposition;
    if (disposition) {
      callDispositionError.value = null;
    }
  }

  // Watcher: auto-select contact's existing disposition
  watch([callDispositions, () => reactiveContact.value?.callDispositionId], () => {
    if (
      callDispositions.value?.length > 0 &&
      !selectedCallDisposition.value &&
      reactiveContact.value?.callDispositionId
    ) {
      const matchingDisposition = callDispositions.value.find(
        (d: any) => d.id === reactiveContact.value.callDispositionId
      );
      if (matchingDisposition) {
        selectedCallDisposition.value = matchingDisposition;
      }
    }
  });

  return {
    selectedCallDisposition,
    callDispositionError,
    mustLogAfterCall,
    hasCallBeenLogged,
    hasBaseCallLogCreated,
    isCallDispositionRequired,
    canProceedWithCall,
    logCallBySid,
    onCallDispositionChange,
  };
}
